var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"games-wrapper"}},[_c('div',{attrs:{"id":"games-page"}},[_c('breadcrumb',{attrs:{"breadcrumb":[
                { title: 'Community', url: '/', status: false },
                { title: 'Games', url: '/games', status: true }
            ]}}),_vm._v(" "),_c('div',{staticClass:"container py-4"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.user.game_racing)}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }